import { routes } from "utilities/routes";

import {
    type ILienWaiverPaymentContext,
    isLastWaiverOnPayment,
} from "entity/bill/LienWaiverReview/LienWaiverReview.api.types";
import { SIGNED_LIEN_WAIVER_PARAM } from "entity/bill/LienWaiverReview/signedLienWaiverPolling";

/** Tells the payment page the sub came from their lien waiver list, so it can offer a way back. */
export const FROM_LIEN_WAIVERS_PARAM = "fromLienWaivers";

/** Where to send the sub once their async Nutrient approval lands, since the payment isn't released yet. */
export const PAYMENT_DESTINATION_PARAM = "paymentDestination";

/** Undefined unless this is the last waiver holding the payment and the payment has a share token to address. */
export function getPaymentDestinationAfterSigning(
    paymentContext: ILienWaiverPaymentContext | undefined,
) {
    if (!paymentContext?.paymentShareToken || !isLastWaiverOnPayment(paymentContext)) {
        return undefined;
    }

    const link = routes.outboundPayments.getOutboundPaymentExternalLink(
        paymentContext.paymentShareToken,
    );

    return `${link}${link.includes("?") ? "&" : "?"}${FROM_LIEN_WAIVERS_PARAM}=true`;
}

export interface ILienWaiverReturnParams {
    signedLienWaiverId?: string;
    paymentDestination?: string;
}

/** Parsed once at the route boundary so the review component takes these as props, not raw query reads. */
export function parseLienWaiverReturnParams(search: string): ILienWaiverReturnParams {
    const params = new URLSearchParams(search);
    return {
        signedLienWaiverId: params.get(SIGNED_LIEN_WAIVER_PARAM) ?? undefined,
        paymentDestination: params.get(PAYMENT_DESTINATION_PARAM) ?? undefined,
    };
}
